import { Command } from 'commander';
import chalk from 'chalk';
import Table from 'cli-table3';
import { ConfigService } from '../../services/config.service.js';
import { StarterKitService } from '../../services/starter-kit.service.js';
import { ValidationError } from '../../errors/index.js';

export function createKitListCommand(): Command {
    return new Command('list')
        .description('List available starter kits')
        .option('-c, --category <category>', 'Filter by category (backend, frontend, fullstack)')
        .option('-s, --search <term>', 'Search kits by name or description')
        .action(async (options) => {
            const configService = new ConfigService();
            const config = await configService.load();

            if (!config) {
                throw new ValidationError('Not initialized. Run "jai1 auth" first.');
            }

            console.log(chalk.cyan('📦 Đang tải danh sách starter kits...'));
            console.log();

            const kitService = new StarterKitService();
            const kits = await kitService.list(config, {
                category: options.category,
                search: options.search,
            });

            if (kits.length === 0) {
                console.log(chalk.yellow('Không tìm thấy starter kits nào.'));
                if (options.category || options.search) {
                    console.log(chalk.dim('Thử bỏ filter để xem tất cả.'));
                }
                return;
            }

            // Group by category
            const byCategory: Record<string, typeof kits> = {};
            for (const kit of kits) {
                if (!byCategory[kit.category]) {
                    byCategory[kit.category] = [];
                }
                byCategory[kit.category].push(kit);
            }

            const categoryOrder = ['frontend', 'backend', 'fullstack'];
            const sortedCategories = Object.keys(byCategory).sort((a, b) => {
                const indexA = categoryOrder.indexOf(a);
                const indexB = categoryOrder.indexOf(b);
                if (indexA === -1 && indexB === -1) return a.localeCompare(b);
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });

            for (const category of sortedCategories) {
                const categoryKits = byCategory[category];
                const categoryIcon =
                    category === 'frontend' ? '🎨' :
                    category === 'backend' ? '⚙️' :
                    category === 'fullstack' ? '🚀' : '📦';

                console.log(
                    chalk.bold(`${categoryIcon} ${category.charAt(0).toUpperCase() + category.slice(1)}`)
                );

                const table = new Table({
                    head: [
                        chalk.cyan('Slug'),
                        chalk.cyan('Mô tả'),
                        chalk.cyan('Version'),
                    ],
                    style: { head: [], border: ['gray'] },
                });

                for (const kit of categoryKits) {
                    table.push([
                        chalk.white(kit.slug),
                        chalk.dim(kit.description.slice(0, 50)),
                        chalk.green(`v${kit.version}`),
                    ]);
                }

                console.log(table.toString());
                console.log();
            }

            console.log(chalk.dim(`Tổng cộng: ${kits.length} starter kit(s)`));
            console.log(chalk.dim('\n💡 Chạy "jai1 kit create <slug>" để tạo project mới'));
        });
}
